import { user } from '../main'

const getUser = () => {
  return { user }
}

export default getUser